module.exports = __webpack_public_path__ + "img/poly-7.88d582db.png";